import { useQuery } from '@pinia/colada'

export function useFeatureFlags() {
  const featureFlagsQuery = useQuery({
    ...buildApiQuery('/feature-flags'),
  })

  async function loadFlags(): Promise<string[]> {
    try {
      await featureFlagsQuery.refresh()
      return featureFlagsQuery.data.value || []
    }
    catch {
      return []
    }
  }

  return {
    loadFlags,
  }
}
